<template>
  <img
    :src="inverted ? '/img/logo-white.svg' : '/img/logo.svg'"
    :height="height"
    :width="Math.round(height * 4.11)"
    alt="Plug2Charge"
    draggable="false"
    class="p2c-logo-img"
  >
</template>

<script setup>
defineProps({
  height:   { type: Number, default: 36 },
  inverted: { type: Boolean, default: false },
})
</script>

<style scoped>
.p2c-logo-img {
  display: inline-block;
  user-select: none;
  flex-shrink: 0;
  vertical-align: middle;
}
</style>
